import type { AuthSession } from './accountTypes'

const storageKey = 'mapapal.authSession'

function isSession(value: unknown): value is AuthSession {
  if (value === null || typeof value !== 'object') return false
  const candidate = value as Partial<AuthSession>
  return typeof candidate.sid === 'string' && candidate.sid.length > 0
    && typeof candidate.username === 'string' && candidate.username.length > 0
}

export function readAuthSession(): AuthSession | null {
  try {
    const value = window.localStorage.getItem(storageKey)
    if (value) {
      const session: unknown = JSON.parse(value)
      if (isSession(session)) return session
    }

    const sid = window.localStorage.getItem('mapa_sid') ?? ''
    const username = window.localStorage.getItem('mapa_user') ?? ''
    const email = window.localStorage.getItem('mapa_email') || undefined
    return sid && username ? { sid, username, email } : null
  } catch {
    return null
  }
}

export function storeAuthSession(session: AuthSession): void {
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(session))
  } catch {
    // The active session still works in memory when persistent storage is blocked.
  }
}

export function clearAuthSession(): void {
  try {
    window.localStorage.removeItem(storageKey)
    window.localStorage.removeItem('mapa_sid')
    window.localStorage.removeItem('mapa_user')
    window.localStorage.removeItem('mapa_email')
  } catch {
    // There is nothing else to clear when storage is unavailable.
  }
}
